/* =========================================================================
   MISHRI GOLD — shared theme behaviour
   Enqueued once in layout/theme.liquid:
   {{ 'mishri-gold.js' | asset_url | script_tag }}
   ========================================================================= */
(function () {
  "use strict";

  /* ---------- Scroll reveal for any .mg-reveal element ---------- */
  function initReveal() {
    var items = document.querySelectorAll(".mg-reveal");
    if (!items.length) return;
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add("in");
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15 }
    );
    items.forEach(function (el) {
      io.observe(el);
    });
  }

  /* ---------- Hero parallax tilt (skipped on touch devices) ---------- */
  function initHeroParallax() {
    var hero = document.querySelector("[data-mg-hero]");
    var frame = document.querySelector("[data-mg-hero-frame]");
    if (!hero || !frame || window.matchMedia("(pointer: coarse)").matches) return;
    hero.addEventListener("mousemove", function (e) {
      var r = hero.getBoundingClientRect();
      var x = (e.clientX - r.left) / r.width - 0.5;
      var y = (e.clientY - r.top) / r.height - 0.5;
      frame.style.transform =
        "rotateY(" + x * 8 + "deg) rotateX(" + -y * 8 + "deg)";
    });
    hero.addEventListener("mouseleave", function () {
      frame.style.transform = "none";
    });
  }

  /* ---------- Wishlist (localStorage-backed) ----------
     Lightweight fallback so the heart icon does something out of the box.
     For a real cross-device wishlist synced to customer accounts, swap
     this for a wishlist app (e.g. Swym, Wishlist King) or a metafield-based
     customer wishlist and call its API here instead. */
  var WISHLIST_KEY = "mishri_gold_wishlist";

  function getWishlist() {
    try {
      return JSON.parse(localStorage.getItem(WISHLIST_KEY) || "[]");
    } catch (e) {
      return [];
    }
  }

  function saveWishlist(list) {
    try {
      localStorage.setItem(WISHLIST_KEY, JSON.stringify(list));
    } catch (e) {
      /* storage unavailable (private mode) — fail silently */
    }
  }

  function initWishlistButtons() {
    var buttons = document.querySelectorAll("[data-mg-wishlist-toggle]");
    if (!buttons.length) return;
    var wishlist = getWishlist();

    buttons.forEach(function (btn) {
      var id = btn.getAttribute("data-mg-wishlist-toggle");
      if (wishlist.indexOf(id) !== -1) btn.classList.add("is-active");

      btn.addEventListener("click", function (e) {
        e.preventDefault();
        var list = getWishlist();
        var idx = list.indexOf(id);
        if (idx === -1) {
          list.push(id);
          btn.classList.add("is-active");
        } else {
          list.splice(idx, 1);
          btn.classList.remove("is-active");
        }
        saveWishlist(list);
        document.dispatchEvent(
          new CustomEvent("mg:wishlist:updated", { detail: { count: list.length } })
        );
      });
    });
  }

  /* ---------- Quick add-to-cart via Shopify's AJAX Cart API ---------- */
  function initQuickAddButtons() {
    var buttons = document.querySelectorAll("[data-mg-add-to-cart]");
    if (!buttons.length) return;

    buttons.forEach(function (btn) {
      btn.addEventListener("click", function (e) {
        e.preventDefault();
        var variantId = btn.getAttribute("data-mg-add-to-cart");
        if (!variantId) return;

        btn.disabled = true;
        fetch(window.Shopify ? "/cart/add.js" : "/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }),
        })
          .then(function (res) {
            if (!res.ok) throw new Error("Add to cart failed");
            return res.json();
          })
          .then(function () {
            // Let Dawn's own cart drawer/notification pick up the change.
            document.dispatchEvent(new CustomEvent("cart:refresh"));
            document
              .querySelectorAll("cart-notification, cart-drawer")
              .forEach(function (el) {
                if (typeof el.open === "function") el.open();
              });
            btn.classList.add("mg-added");
            setTimeout(function () {
              btn.classList.remove("mg-added");
            }, 1500);
          })
          .catch(function (err) {
            console.error("Mishri Gold: add to cart error", err);
          })
          .finally(function () {
            btn.disabled = false;
          });
      });
    });
  }

  /* ---------- Newsletter form feedback (native Shopify customer form) ---------- */
  function initNewsletterForm() {
    var note = document.querySelector("[data-mg-newsletter-note]");
    if (!note) return;
    var params = new URLSearchParams(window.location.search);
    if (params.get("customer_posted") === "true") {
      note.textContent = "Thank you — you are on the list.";
      note.classList.add("success");
    }
  }

  document.addEventListener("DOMContentLoaded", function () {
    initReveal();
    initHeroParallax();
    initWishlistButtons();
    initQuickAddButtons();
    initNewsletterForm();
  });

  // Re-init reveal targets for sections added/edited live in the theme editor.
  document.addEventListener("shopify:section:load", function () {
    initReveal();
    initWishlistButtons();
    initQuickAddButtons();
  });
})();
